import React, { useState } from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import WorkOrderModal from '../WorkOrderModal';
import moment from 'moment';

const formatDate = (value) => {
  if (!value) return '-';
  const mDate = moment(value);
  if (!mDate.isValid()) return '-';
  return mDate.format('MMM D, h:mm A');
};

const Column = ({ columnId, title, tasks, onRefresh }) => {
  const [editItem, setEditItem] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  return (
    <Droppable droppableId={columnId}>
      {(provided, snapshot) => (
        <div
          className={`work-order-kanban-column ${snapshot.isDraggingOver ? 'is-dragging-over' : ''}`}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          <h6 className="work-order-kanban-column__title">{title}</h6>
          <div className="work-order-kanban-column__tasks">
            {tasks.length === 0 && (
              <div className="work-order-kanban-column__empty">
                No work orders
              </div>
            )}
            {tasks.map((task, index) => (
              <Draggable
                key={task.id}
                draggableId={task.id}
                index={index}
                isDragDisabled={task.isDragDisabled}
              >
                {(dragProvided, dragSnapshot) => (
                  <div
                    className={`work-order-kanban-card ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                    ref={dragProvided.innerRef}
                    {...dragProvided.draggableProps}
                    {...dragProvided.dragHandleProps}
                  >
                    <div
                      className={`wo-badge wo-badge-priority-${task.row.priority + 1}`}
                    >
                      Priority {task.row.priority || 1}
                    </div>
                    <div className="work-order-kanban-card__guest">
                      {task.row.workOrderType || '-'}
                    </div>
                    <div
                      className="work-order-kanban-card__date"
                      style={{ color: '#143652', fontWeight: 500 }}
                    >
                      {task.row.roomTitle || ''}
                      {/* {task.row.facilityId ? `(${task.row.facilityId})` : ''} */}
                    </div>
                    <div
                      className="work-order-kanban-card__date text-truncate"
                      title={task.row.message}
                    >
                      {task.row.message || '-'}
                    </div>
                    <div className="work-order-kanban-card__date mt-2">
                      <i className="simple-icon-clock mr-1" />
                      {formatDate(task.row.executionUtc)}
                    </div>
                    <div className="work-order-kanban-card__actions">
                      {task.isDragDisabled && (
                        <div className="work-order-kanban-card__lock-wrapper">
                          <button
                            type="button"
                            className="work-order-kanban-card__lock-btn"
                          >
                            <i className="simple-icon-lock" />
                          </button>
                          <div className="work-order-kanban-card__tooltip">
                            Synced from Flexkeeping
                          </div>
                        </div>
                      )}
                      <button
                        type="button"
                        className="work-order-kanban-card__edit-btn"
                        onClick={() => {
                          setEditItem(task.row);
                          setIsEditModalOpen(true);
                        }}
                        aria-label="Edit work order"
                      >
                        <i className="simple-icon-note" />
                      </button>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
          {isEditModalOpen && (
            <WorkOrderModal
              visible={isEditModalOpen}
              toggle={() => {
                setIsEditModalOpen(false);
                setEditItem(null);
              }}
              onSuccess={onRefresh}
              item={editItem}
            />
          )}
        </div>
      )}
    </Droppable>
  );
};

export default Column;
